export const BirdviewDwellerWidget = {
  Announcements: 'announcements',
  Documents: 'documents',
  Home: 'home',
  Messages: 'messages',
  Objects: 'objects',
  Requests: 'requests',
}

export const BIRDVIEW_DWELLER_WIDGET_TITLE_KEY = {
  [BirdviewDwellerWidget.Announcements]:
    'DashboardBirdview.AnnouncementsTitleKey',
  [BirdviewDwellerWidget.Documents]: 'DashboardBirdview.DocumentsTitleKey',
  [BirdviewDwellerWidget.Home]: 'DashboardBirdview.HomeTitleKey',
  [BirdviewDwellerWidget.Messages]: 'DashboardBirdview.MessagesTitleKey',
  [BirdviewDwellerWidget.Objects]: 'DashboardBirdview.ObjectsTitleKey',
  [BirdviewDwellerWidget.Requests]: 'DashboardBirdview.RequestsTitleKey',
}

// Home is a parameters block, not a list, so none of its rows are cut.
export const BIRDVIEW_DWELLER_HOME_ITEMS_LIMIT = Infinity

export const BIRDVIEW_DWELLER_LAYOUT = {
  left: [
    BirdviewDwellerWidget.Requests,
    BirdviewDwellerWidget.Messages,
    BirdviewDwellerWidget.Documents,
  ],
  right: [BirdviewDwellerWidget.Home, BirdviewDwellerWidget.Announcements],
}

export const BIRDVIEW_LANDLORD_LAYOUT = {
  left: [
    BirdviewDwellerWidget.Objects,
    BirdviewDwellerWidget.Requests,
    BirdviewDwellerWidget.Documents,
  ],
  right: [BirdviewDwellerWidget.Announcements, BirdviewDwellerWidget.Messages],
}
